import ChatbotSectionCard from "@root/components/dashboard/ChatbotSectionCard";
import SingleDocument from "@root/components/dashboard/UploadDashboad.tsx/SingleDocument";
import { UploadDocument } from "@root/components/dashboard/UploadDashboad.tsx/UploadDocument";
import { ROUTE_NAMES } from "@root/constants";
import { CountryProvider } from "@root/context";
import { GlobalContextProvider } from "@root/context/global-context";
import { KPSChatProvider } from "@root/context/kps-chat-context";
import { DashboardProvider } from "@root/context/kps-dashboard-context";
import DashboardLayout from "@root/layouts/DashboardLayout";
import OpenLayout from "@root/layouts/OpenLayout";
import {
  ChatHistory,
  ContactUsScreen,
  PrivacyPolicy,
  TermsConditions,
  UserSettingProfile,
} from "@root/pages";
import { AdminUserManagementScreen } from "@root/pages/admin-user-management";
import ChecklistPage from "@root/pages/checklist";
import { MainChatContainer } from "@root/pages/dashboard/components/mainChat";
import { UserProjectsDashboard } from "@root/pages/dashboard/projectsDashboard";
import { ChatHistoryPage } from "@root/pages/dashboardpage/chatbot-history-page";
import { DashboardPage } from "@root/pages/dashboardpage/dashboard";
import AllReports from "@root/pages/dashboardpage/all-reports";
import DocumentsViewer from "@root/pages/doc-viewer";
import { DrawingAnalysis } from "@root/pages/drawing-analysis-chatbot/drawing-analysis-chatbot";
import { DrawingPreview } from "@root/pages/drawing-preview/drawing-preview";
import { LegalReview } from "@root/pages/legal-review/legal-review";
import { MaterialComparison } from "@root/pages/material-camparison";
import LoadingWithText from "@root/pages/permit-review/loading";
import { PermitReview } from "@root/pages/permit-review/permit_review";
import { Navigate, createBrowserRouter } from "react-router-dom";

export const protectedRoutes = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to={ROUTE_NAMES.DASHBOARD} />,
  },

  {
    path: "/",
    element: <OpenLayout />,
    children: [
      {
        path: ROUTE_NAMES.SHARED_THREAD,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.SHARED_CHAT,
        element: <MainChatContainer />,
      },
    ],
  },
  {
    path: "/",
    element: (
      <GlobalContextProvider>
        <DashboardProvider>
          <KPSChatProvider>
            <CountryProvider>
              <DashboardLayout />
            </CountryProvider>
          </KPSChatProvider>
        </DashboardProvider>
      </GlobalContextProvider>
    ),
    children: [
      {
        path: ROUTE_NAMES.ADMIN_USER_MANAGEMENT,
        element: <AdminUserManagementScreen />,
      },
      {
        path: ROUTE_NAMES.LEGAL_CHATBOT,
        element: <UserProjectsDashboard key="legal" />,
      },
      {
        path: ROUTE_NAMES.DOCUMENT_INTEGRATION_CHATBOT,
        element: <UserProjectsDashboard key="doc-integration" />,
      },
      {
        path: ROUTE_NAMES.KCS,
        element: <UserProjectsDashboard />,
      },
      {
        path: ROUTE_NAMES.SINGLE_PERMIT_REVIEW,
        element: <SingleDocument />,
      },
      {
        path: ROUTE_NAMES.SINGLE_EXTRACTION_REVIEW,
        element: <SingleDocument />,
      },
      {
        path: ROUTE_NAMES.MATERIAL_CAMPARISON_BY_ID,
        element: <SingleDocument />,
      },
      {
        path: ROUTE_NAMES.PERMIT_REVIEW,
        element: <UploadDocument />,
      },
      {
        path: ROUTE_NAMES.DRAWING_ANALYSIS,
        element: <UploadDocument />,
      },
      {
        path: ROUTE_NAMES.DRAWING_ANALYSIS_CHAT,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.DRAWING_ANALYSIS_DASHBOARD,
        element: <UserProjectsDashboard />,
      },
      {
        path: ROUTE_NAMES.KCS_CHAT,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.KCS_CHAT_BY_ID,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.DASHBOARD,
        element: <DashboardPage />,
        // element: <DashboardPage />,
      },
      {
        path: ROUTE_NAMES.CHAT_HISTORY_DASHBOARD,
        element: <ChatHistoryPage />,
      },
      {
        path: ROUTE_NAMES.UPLOAD_DOCUMENT,
        element: <UploadDocument />,
      },
      {
        path: ROUTE_NAMES.DRAWING_ANALYSIS_CHAT_BY_ID,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.LEGAL_REVIEW,
        element: <UploadDocument />,
      },
      {
        path: ROUTE_NAMES.SINGLE_LEGAL_REVIEW,
        element: <SingleDocument />,
      },
      {
        path: ROUTE_NAMES.RISKCHECKER_CHAT_SCREEN,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.CONGPT_CHAT_SCREEN,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.KSCE_CHAT_SCREEN,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.DOCUMENT_CHAT,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.CHECKLIST_CHAT,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.CHAT_HISTORY,
        element: <ChatHistory />,
      },
      {
        path: ROUTE_NAMES.PRIVACY_POLICY,
        element: <PrivacyPolicy />,
      },
      {
        path: ROUTE_NAMES.TERMS_CONDITION,
        element: <TermsConditions />,
      },
      {
        path: ROUTE_NAMES.CHAT_BY_ID,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.DOCUMENT_CHAT_BY_ID,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.CHECKLIST_CHAT_BY_ID,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.CONTACT,
        element: <ContactUsScreen />,
      },
      {
        path: ROUTE_NAMES.CHAT_HISTORY,
        element: <ChatHistory />,
      },
      {
        path: ROUTE_NAMES.USER_PROFILE,
        element: <UserSettingProfile />,
      },
      {
        path: ROUTE_NAMES.CHECKLIST,
        element: <UserProjectsDashboard />,
      },
      {
        path: ROUTE_NAMES.MATERIAL_CAMPARISON,
        element: <MaterialComparison />,
      },
      {
        path: ROUTE_NAMES.LOADING,
        element: <LoadingWithText />,
      },
      {
        path: ROUTE_NAMES.DRAWING_PREVIEW,
        element: <DrawingPreview />,
      },
      {
        path: ROUTE_NAMES.DOC_VIEWER,
        element: <DocumentsViewer />,
      },
      {
        path: ROUTE_NAMES.ALL_REPORTS,
        element: <AllReports />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to={ROUTE_NAMES.DASHBOARD} />,
  },
]);
